export enum BatchChangeType {
  Copy = 0,
  Update = 1,
  Delete = 2,
  Function = 3,
  ApplyChanges = 4,
  BulkAdd = 5
}

export const BatchChangeTypeMapping: Record<BatchChangeType, string> = {
  [BatchChangeType.Copy]: 'Copy',
  [BatchChangeType.Update]: 'Update',
  [BatchChangeType.Delete]: 'Delete',
  [BatchChangeType.Function]: 'Applying',
  [BatchChangeType.ApplyChanges]: 'Applying Changes',
  [BatchChangeType.BulkAdd]: 'Bulk Add'
};
